import { LoginMode } from 'apprise-core/auth'
import { User } from 'apprise-core/user'
import { createProvider, createReadonlyProvider } from 'apprise-frontend-core/state/factory'



// logged
//------------------------------------------------------------------------------------------------

export const [LoginProvider, useLoginState ] = createProvider({

    logged: undefined! as User

})


// config
//------------------------------------------------------------------------------------------------

export type LoginConfig = {

    mode: LoginMode
}

export const [LoginConfigProvider, useLoginConfig ] = createReadonlyProvider<LoginConfig>({

    mode: 'walled'

})
